
import React from 'react';
import { Users, HeartPulse, ShieldAlert, Activity, Clock, LogIn } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';

export const SimStatsHUD: React.FC = () => {
  const { state } = useAppContext();
  const { stats, isRunning } = state;

  if (!isRunning && stats.activePatients === 0 && stats.treatedPatients === 0) return null;

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-4 pointer-events-none">
      <div className="flex gap-1 bg-slate-900/60 backdrop-blur-xl border border-cyan-500/20 rounded-2xl p-1 shadow-2xl">
        
        {/* Active Patients */}
        <div className="px-4 py-2 flex flex-col items-center border-r border-white/5">
          <div className="flex items-center gap-2 text-cyan-400 mb-0.5">
            <Users size={14} className={stats.activePatients > 15 ? "animate-pulse" : ""} />
            <span className="text-[10px] font-rajdhani font-bold uppercase tracking-widest opacity-60">Pacientai</span>
          </div>
          <span className="text-xl font-mono font-bold text-white text-glow leading-none">
            {stats.activePatients}
          </span>
        </div>

        {/* Treated */}
        <div className="px-4 py-2 flex flex-col items-center border-r border-white/5">
          <div className="flex items-center gap-2 text-emerald-400 mb-0.5">
            <HeartPulse size={14} />
            <span className="text-[10px] font-rajdhani font-bold uppercase tracking-widest opacity-60">Išgydyta</span>
          </div>
          <span className="text-xl font-mono font-bold text-white leading-none">
            {stats.treatedPatients}
          </span>
        </div>

        {/* Critical Events */}
        <div className="px-4 py-2 flex flex-col items-center border-r border-white/5">
          <div className="flex items-center gap-2 text-red-400 mb-0.5">
            <ShieldAlert size={14} className={stats.criticalEvents > 0 ? "animate-urgent" : ""} />
            <span className="text-[10px] font-rajdhani font-bold uppercase tracking-widest opacity-60">Kritiniai</span>
          </div>
          <span className="text-xl font-mono font-bold text-white leading-none">
            {stats.criticalEvents}
          </span>
        </div>

        {/* Infections */}
        <div className="px-4 py-2 flex flex-col items-center border-r border-white/5">
          <div className="flex items-center gap-2 text-lime-400 mb-0.5">
            <Activity size={14} />
            <span className="text-[10px] font-rajdhani font-bold uppercase tracking-widest opacity-60">Užkratai</span>
          </div>
          <span className="text-xl font-mono font-bold text-white leading-none">
            {stats.infections}
          </span>
        </div>

        {/* Avg Wait Time */}
        <div className="px-4 py-2 flex flex-col items-center">
          <div className="flex items-center gap-2 text-amber-400 mb-0.5">
            <Clock size={14} />
            <span className="text-[10px] font-rajdhani font-bold uppercase tracking-widest opacity-60">Laukimas</span>
          </div>
          <span className="text-xl font-mono font-bold text-white leading-none">
            {stats.avgWaitTime.toFixed(0)}<span className="text-[10px] ml-0.5 opacity-50">min</span>
          </span>
        </div>

      </div>

      {/* Simulation Running Indicator */}
      <div className={`flex items-center gap-3 px-4 py-2 rounded-2xl border backdrop-blur-md transition-all ${isRunning ? 'bg-emerald-500/10 border-emerald-500/30' : 'bg-red-500/10 border-red-500/30'}`}>
        <div className={`w-2 h-2 rounded-full ${isRunning ? 'bg-emerald-500 animate-pulse box-glow' : 'bg-red-500'}`}></div>
        <span className={`text-[10px] font-rajdhani font-bold uppercase tracking-widest ${isRunning ? 'text-emerald-400' : 'text-red-400'}`}>
          {isRunning ? 'Simuliacija aktyvi' : 'Sustabdyta'}
        </span>
      </div>
    </div>
  );
};
